import { Card, Divider, Input, message, Modal, Rate, Tag } from "antd"
import { useDispatch, useSelector } from "react-redux";
import "./index.scss";
import { setModalState, updateModalParams, updateTask } from "../../store/reducers/Modal/actions";
import { FaLock } from '@react-icons/all-files/fa/FaLock';
import { useEffect, useState } from "react";
import { postRequest } from "../../services/requestService";
import Button from "../../components/forms/Button";
import { copyToClipboard } from "../../services/clipboardService";
import TextArea from './Components/TextArea'
import { FaPhone } from '@react-icons/all-files/fa/FaPhone'
import { MdMail } from '@react-icons/all-files/md/MdMail'
import { formatToUSPhoneNumber } from "../../services/textService";
import { BUTTON_VARIANT_LINK } from "../../components/forms/Button/constants";
import { getLastResume } from "../../services/resumeService";
import downloadCoverLetterAsPDF from "./service";
import { reportEvent, trackServerEvent } from "../../services/analyticsService";
const CoverLetterModal = props => {
    const { isCoverLetterModalOpen, savedJob } = useSelector(({ ModalReducer }) => ModalReducer);
    const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer);
    const [saveLoading, setSaveLoading] = useState();
    const [generateLoading, setGenerateLoading] = useState(false)
    const [generateInstructions, setGenerateInstructions] = useState('')
    const [text, setText] = useState('')
    const coverLetterText = savedJob?.application?.coverLetterText || ""
    const dispatch = useDispatch()
    const resume = getLastResume(userDetails);
    const [copyLoader, setCopyLoader] = useState(false)




    useEffect(() => {
        if (isCoverLetterModalOpen && savedJob) {
            setText(savedJob.application?.coverLetterText)
        }
    }, [isCoverLetterModalOpen]);

    const onClose = () => {
        dispatch(setModalState('isCoverLetterModalOpen', false))
        dispatch(setModalState('isApplicationModalOpen', true, { savedJob }))
    }
    const onCopyToClipboard = () => {
        reportEvent('cover_letter', 'export_click', { source: 'editorClipboard' })
        setCopyLoader(true)
        setTimeout(() => {
            copyToClipboard(coverLetterText)
            message.success("Copied to clipboard 🎉")
        }, 2500)
    }

    const onSaveChanges = async () => {
        setSaveLoading(true)
        const res = await postRequest('saved-job/update', { "application.coverLetterText": text })
        // TODO: Update the cover letter application.coverLetterText
        // TODO: Close
        // await postRequest('application/update', {"application.coverLetterText": saved})
        message.success("Your cover letter was saved succesfully!")
        dispatch(updateModalParams({ savedJob: res.data.savedJob }))
        setSaveLoading(false)
    }
    const onRegenerate = async () => {
        trackServerEvent('regenerate-cover-letter')
        if (!generateInstructions) return;
        setGenerateInstructions('')
        setGenerateLoading(true)
        const res = await postRequest('application/edit-cover', { savedJobId: savedJob._id, instructions: generateInstructions })
        // dispatch(updateModalParams({ savedJob: res.data.savedJob }))
        setText(res.data.coverLetterText)
        setGenerateLoading(false)
    }
    const onDownloadClick = () => {
        trackServerEvent('download-cover-letter-via-modal')
        reportEvent('cover_letter', 'export_click', { source: 'editorDownload' })
        downloadCoverLetterAsPDF(userDetails, resume, text, savedJob?.job?.title)
        reportEvent('cover_letter', 'export_success', { source: 'editorDownload' })
        dispatch(updateTask(savedJob, 'generateCover', true))

    }

    if (!savedJob || !resume) return null;
    const isChanged = coverLetterText !== text;

    return (
        <Modal className="cover-letter-modal"
            onCancel={() => onClose()}
            open={isCoverLetterModalOpen} footer={null}>
            <div className="top-actions">
                <Button onClick={onDownloadClick}>Download PDF</Button>
                <Button onClick={onCopyToClipboard}>Copy to clipboard</Button>
            </div>

            <div className="cover-letter-content">
                <div className="top-cover-letter">
                    <div className="candidate-name">{userDetails?.name}</div>
                    <br />
                    <div className="contact-info">
                        {resume?.phoneNumber && <div className="phone">
                            <FaPhone />
                            {formatToUSPhoneNumber(resume?.phoneNumber || '')}
                        </div>}
                        <div className="email">
                            <MdMail />
                            {resume?.email}
                        </div>
                    </div>
                </div>
                <Divider />
                <TextArea
                    value={text} onChange={newVal => setText(newVal)}
                />
            </div>
            <div className="optimize-text">
                <div className="left">
                    <Input placeholder="What would you like to change?"
                        value={generateInstructions} onChange={e => setGenerateInstructions(e.target.value)}
                    />
                    <br />
                    {["Make it shorter", "Make it catchy", "Make it more formal", "Translate to Spanish"].map(tag => <Tag onClick={() => {
                        setGenerateInstructions(tag)
                    }}>{tag}</Tag>)}
                </div>
                <div className="right">
                    <Button loading={generateLoading} disabled={!generateInstructions} onClick={onRegenerate}>Regenerate</Button>
                </div>
            </div>

            <div className="bottom-actions">
                <Button variant={BUTTON_VARIANT_LINK} onClick={onClose}>Close</Button>
                <Button disabled={!isChanged} onClick={onSaveChanges} loading={saveLoading}>Save Changes</Button>
            </div>

        </Modal>
    )
}

export default CoverLetterModal;